export function Kpi({
  label,
  valor,
  unidad,
  pie,
  variante,
}: {
  label: string;
  valor: string;
  unidad?: string;
  pie: string;
  variante?: 'acento' | 'atencion';
}) {
  return (
    <li className={['mesa-kpi', variante ? `mesa-kpi--${variante}` : ''].filter(Boolean).join(' ')}>
      <p className="mesa-kpi__label">{label}</p>
      <p className="mesa-stat">
        {valor}
        {unidad && <span className="mesa-kpi__unidad">{unidad}</span>}
      </p>
      <p className="mesa-kpi__pie">{pie}</p>
    </li>
  );
}
